import type { RetirementOverview, RetirementQuery } from '../types/retirement'
import { fetchApi } from './api'

/**
 * Retirement candidates: ObservatoryRetirementController, LighthouseAdmin at class
 * level, GET only.
 *
 * Through the shared `fetchApi`, so a failure arrives as an ApiError carrying its
 * status and the page can tell a 403 (RestrictedState) from a 500 from an empty
 * list. It can only do that by status.
 */

const BASE = '/api/observatory/retirement'

export function getRetirementCandidates(query: RetirementQuery = {}): Promise<RetirementOverview> {
  const params = new URLSearchParams()
  if (query.skip != null) params.set('skip', String(query.skip))
  if (query.top != null) params.set('top', String(query.top))

  // Only a real filter is sent. The controller REFUSES a blank `reason` with a 400
  // rather than reading it as "every signal", so "All" is the parameter's absence.
  if (query.reason) params.set('reason', query.reason)

  const qs = params.toString()
  return fetchApi<RetirementOverview>(`${BASE}${qs ? `?${qs}` : ''}`)
}
